export const PRIVACY_POLICY_URL = "https://www.one10marketing.com/privacy-policy/";
export const GDPR_PRIVACY_EMAIL = "privacyofficer@one10marketing.com";

export const CARDHOLDER_AGREEMENT_FILENAME = "cardholder_agreement.pdf";
export const ISSUING_BANK_PRIVACY_FILENAME = "issuing_bank_privacy_policy.pdf";
export const ESIGN_AGREEMENT_FILENAME = "esign_agreement.pdf";
export const FAQ_FILENAME = "faq.pdf";
export const MARKETPLACE_TERMS_FILENAME = "marketplace_terms_and_conditions.pdf";

export const TERMS_DOCUMENT_ID = "terms";
export const PRIVACY_DOCUMENT_ID = "privacy";
export const PRIVACY_GDPR_DOCUMENT_ID = "privacy_gdpr";

export function gdprPrivacyMailto() {
  return `mailto:${GDPR_PRIVACY_EMAIL}?subject=GDPR Data Request`;
}

export function isPrivacyDocumentId(docname) {
  return docname === PRIVACY_DOCUMENT_ID || docname === PRIVACY_GDPR_DOCUMENT_ID;
}

export function openPrivacyPolicy() {
  window.open(PRIVACY_POLICY_URL, "_blank", "noopener,noreferrer");
}
